import { type schemaType } from '~~/shared/api/rurality/v3/travelers/optIn/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/travelers/optIn/paramsSchema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/travelers/optIn'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapper<paramsType, schemaType>(endpoint, params)
